import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    CollectionDeDossierCollectiondossierUpdate,
    CollectionDeDossierJsonldCollectiondossierRead,
    DossierOpenSearchApiApiOpensearchDossiersGetCollectionRequest,
    DossierOpenSearchJsonldOpensearchDossierRead,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { UpdateCollectionPayload } from '../types';

export type CollectionDossier = DossierOpenSearchJsonldOpensearchDossierRead &
    Record<string, unknown>;

type searchParamProps = {
    numero: string[];
};
const useCollectionDossier = () => {
    const { dossierOpenSearchApi, collectionApi } = useFormaliteService();
    let searchCollectionTimeout: number | undefined;

    const searchDossiers = ({ numero }: searchParamProps): Promise<Array<CollectionDossier>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchCollectionTimeout);
            const requestParameters: DossierOpenSearchApiApiOpensearchDossiersGetCollectionRequest =
                {
                    numero: numero || undefined,
                    itemsPerPage: 20,
                };

            searchCollectionTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchDossiersGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as CollectionDossier[]))
                    .catch(() => reject());
            }, 300);
        });

    const updateCollections = async (
        ids: number[],
        payload: UpdateCollectionPayload,
    ): Promise<Array<CollectionDeDossierJsonldCollectiondossierRead>> => {
        const collectionDeDossierCollectiondossierUpdate: CollectionDeDossierCollectiondossierUpdate =
            {
                client:
                    payload.clientId !== undefined
                        ? `/tiers/tiers/${String(payload.clientId)}`
                        : undefined,
                venteIndirecte:
                    payload.venteIndirecte !== undefined ? payload.venteIndirecte : undefined,
            };

        const promises = ids.map((id) =>
            collectionApi.apiCollectionsDossiersIdPatch({
                id: String(id),
                collectionDeDossierCollectiondossierUpdate,
            }),
        );
        const responses = await Promise.all(promises);

        return responses.map((res) => res.data);
    };

    return { searchDossiers, updateCollections };
};

export default useCollectionDossier;
